module.exports = __webpack_public_path__ + "media/lower gi bleeding.6fe36560.wav";